/**
 * The name of the product, as the interface shows it. Set at build time from the
 * installation's APP_NAME (docker compose passes it on as VITE_APP_NAME).
 */
export const APP_NAME: string = import.meta.env.VITE_APP_NAME?.trim() || 'EasyMusic';
